module.exports = fn.banners;